const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
//const BASE_URL = "https://www.googleapis.com/youtube/v3/search";


const CHANNEL_IDS = [
  "UCm-xshfhKfhSwt5YtCBB6AA", // Telugu Cinema Muchhatlu
  "UCd56xsfnWpx79BVOZ4G7SEQ", // Chathurya TV
];

export async function fetchYoutubeShorts() {
  if (!API_KEY) {
    console.error("❌ Missing REACT_APP_YOUTUBE_API_KEY");
    return [];
  }

  let allVideos = [];

  for (const channelId of CHANNEL_IDS) {
    const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&type=video&videoDuration=short&videoEmbeddable=true&maxResults=25&order=date&key=${API_KEY}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (data?.items?.length) {
        const formatted = data.items.map((item) => ({
          videoId: item.id.videoId,
          title: item.snippet.title,
          channel: item.snippet.channelTitle,
          thumbnail: item.snippet.thumbnails?.high?.url,
          publishedAt: item.snippet.publishedAt,
        }));

        allVideos = [...allVideos, ...formatted];
      }
    } catch (err) {
      console.error("Error fetching shorts:", err);
    }
  }

  // ✅ Mix + latest first
  allVideos.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));

  return allVideos;
}
